import { j as i } from "./jsx-runtime-DmTjM30f.mjs";
import * as j from "react";
import { forwardRef as I, useState as y } from "react";
import { I as D } from "./ic_add-Vjwi0Osr.mjs";
import { c as M } from "./index.js-Cr0Rsuyz.mjs";
import { c as S } from "./index-BpNK5r1N.mjs";
import { T as R } from "./text-field-B-iyuBbQ.mjs";
import { c as z } from "./tw-cn-mXgPecoF.mjs";
function A(d, m) {
  return /* @__PURE__ */ j.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: m
  }, d), /* @__PURE__ */ j.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 12.001a.75.75 0 0 1-.75.75H4.75a.75.75 0 0 1 0-1.5h14.5a.75.75 0 0 1 .75.75",
    clipRule: "evenodd"
  }));
}
var F = M(/* @__PURE__ */ I(A));
const H = S("flex w-fit shrink-0 items-center"), $ = S(
  [
    "flex min-h-36 min-w-34 shrink-0 items-center justify-center border  border-line-neutral-weak3 p-4",
    "hover-never:bg-interaction-neutral-presshover-weak1 active:bg-interaction-neutral-presshover-weak1",
    "disabled:bg-fill-neutral-weak [&>*]:disabled:!text-interaction-neutral-disable-main",
    "disabled:hover-never:bg-fill-neutral-weak "
  ],
  {
    variants: {
      type: {
        minus: "border-r-0 rounded-l-8",
        plus: "border-l-0 rounded-r-8"
      }
    }
  }
), O = I((d, m) => {
  const {
    id: w,
    defaultValue: V = "",
    value: N,
    min: r = 0,
    max: l = 999,
    disabled: n = !1,
    className: B,
    onChange: t,
    onInvalidRange: s
  } = d, p = w ? `${w}-` : "", [E, u] = y(`${V}`), [g, b] = y(!1), o = N !== void 0, c = o ? `${N}` : E, f = Number(c) <= r || n, x = Number(c) >= l || n, h = (e) => {
    if (e === "")
      return !1;
    const a = Number(e);
    return Number.isInteger(a);
  }, v = (e) => {
    e < r ? (s == null || s(e), o ? t == null || t(r) : u(`${r}`)) : e > l ? (s == null || s(e), o ? t == null || t(l) : u(`${l}`)) : o ? t == null || t(e) : u(`${e}`);
  }, k = (e) => {
    const a = Number(c || r) + e;
    v(a);
  }, C = (e) => {
    const a = e.target.value;
    if (b(!1), a === "") {
      s == null || s(""), b(!0), o ? t == null || t(r) : u(`${r}`);
      return;
    }
    h(a) && v(Number(a));
  }, T = (e) => {
    const a = e.target.value;
    h(a) || (b(!1), v(r));
  };
  return /* @__PURE__ */ i.jsxs("div", { className: z(H(), B), children: [
    /* @__PURE__ */ i.jsx(
      "button",
      {
        "aria-disabled": f || void 0,
        "aria-label": "마이너스 버튼",
        className: $({ type: "minus" }),
        disabled: f,
        id: `${p}stepper-minus`,
        onClick: () => {
          k(-1);
        },
        tabIndex: f ? -1 : 0,
        type: "button",
        children: /* @__PURE__ */ i.jsx(F, { className: "size-16 text-text-neutral-main" })
      }
    ),
    /* @__PURE__ */ i.jsx(
      R,
      {
        "aria-disabled": n || void 0,
        "aria-label": "숫자 입력",
        className: "w-fit",
        disabled: n,
        id: `${p}stepper-input`,
        inputClassName: "text-center !font-bold",
        inputMode: "numeric",
        inputWrapperClassName: "!p-4 rounded-none min-h-36 pc:min-h-36 w-40 pc:w-40 !border-[1px]",
        max: l,
        min: r,
        onBlur: T,
        onChange: C,
        ref: m,
        tabIndex: n ? -1 : 0,
        type: "number",
        value: g ? "" : c
      }
    ),
    /* @__PURE__ */ i.jsx(
      "button",
      {
        "aria-disabled": x || void 0,
        "aria-label": "플러스 버튼",
        className: $({ type: "plus" }),
        disabled: x,
        id: `${p}stepper-plus`,
        onClick: () => {
          k(1);
        },
        tabIndex: x ? -1 : 0,
        type: "button",
        children: /* @__PURE__ */ i.jsx(D, { className: "size-16 text-text-neutral-main" })
      }
    )
  ] });
});
O.displayName = "NDS.Stepper";
export {
  O as S
};
